"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioButton_1 = require("./RadioButton");
exports.default = RadioButton_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/RadioGroup/components/RadioButton/index.js
// module id = 594
// module chunks = 8